import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useHistory,useParams } from "react-router-dom";
import Button from "components/button/button";
import toast from "react-hot-toast";
import { InvitationAccepted } from "constants/images";
import LoadingIndicator from "assets/svg/loading-indicator";
import { useNotifications } from "redux/modules/notification/hooks";
import { randomExtension,urlSerializer } from "utils/utils";

export default function InvitationEmail() {
  const { http } = global.services;

  const { userData } = useSelector((state) => state.user);
  const extension = randomExtension();
  const { id } = useParams();

  const history = useHistory();
  const query = useQuery();
  const status = query.get("status");
  const notification_ID = query.get("notification");
  const [isLoading,setLoading] = useState(true);
  const {setNotifications} = useNotifications();

  const onResponse = async (status) => {
     try {
        setLoading(true)
        const { data } = await http.put(`public/user-accesses/${id}/response`, {
        status,
        notification: notification_ID,
      });
        await getNotifications();
        setLoading(false)

     
    } catch (err) {
      let error = err.data
      toast.error(`Something went wrong. ${error?.message}`);
    } finally {
        setLoading(false)
    }
  };

    async function getNotifications() {
      try {
        const url = urlSerializer("notifications", {
          limit: 5,
          offset: 0,
          user_id: userData.user.id,
          user_profile_id: userData.profile.id,
          header:Boolean(true),
          unreadOnly:Boolean(true)
        });
        const { data } = await http.get(url);
        setNotifications(data);
      } catch (err) {
        console.log(err);
      }
    }

  useEffect(() => {
      onResponse(status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return (
    <div className="h-screen flex justify-center items-center">
      <div className="w-96 shadow-md rounded-md text-center p-8 mb-20">
        <div className="w-full">
            <div className="w-24.5 h-24.5 mx-auto">
              <img
                src={InvitationAccepted}
                alt="invitation-sent-access"
                className="w-24.5 h-24.5"
              />
            </div>
            <div className="w-full mt-6 text-center leading-6 px-4">
                {
                    isLoading ? 
                      <p className="text-xl text-lightBlack font-semibold">
                        Profile Invitation {status === "declined" ? "Rejecting" : "Approving"}... 
                    </p>
                    :
                      <p className="text-xl text-lightBlack font-semibold">
                            Profile Invitation {status === "declined" ? "Declined" : "Accepted"}
                        </p>
                }
            
            </div>
            <div className="w-full mt-2 flex items-center justify-center space-x-2">
                 {
                isLoading ? 
                 <Button
                    key="notification-email"
                    buttonName={"Loading "}
                    buttonClass="bg-primary py-4 px-8 hover:bg-darkPrimary min-w-[7rem]"
                    buttonTextClass="w-full text-white text-sm font-semibold flex items-center justify-center"
                    disabled={true}
                    loadingIcon={
                        <LoadingIndicator className="text-white w-4 h-4 ml-2" />
                    }
                />
                :
                <Button
                    buttonWidth="100%"
                    buttonName="Got it"
                    buttonTextClass="text-sm text-lightBlack font-semibold leading-4.4"
                    buttonRadius="6px"
                    buttonClass="bg-thBg py-4"
                    onClick={()=>{
                           history.push(`/${userData.user.username}-${extension}/profile/${userData.profile.id}`);
                    }}
                />
              }
              
            
            </div>
          </div>
      </div>
    </div>
  );
}

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};
